import { t } from "i18next";

export const mealOptions = [
  { id: "Desayuno", name: t("contexts.nutrition.breakfast") },
  { id: "Almuerzo", name: t("contexts.nutrition.lunch") },
  { id: "Comida", name: t("contexts.nutrition.meal") },
  { id: "Merienda", name: t("contexts.nutrition.snack") },
  { id: "Cena", name: t("contexts.nutrition.dinner") },
  { id: "Resopón", name: t("contexts.nutrition.redinner") },
];
